export default __webpack_public_path__ + "3c20f6df73c09f53547fa13cee5d7a5d.svg";